import { createBrowserRouter } from "react-router-dom";
import { Final, Game, Table } from "../pages";

export enum ROUTES {
  GAME = "/",
  FINAL = "/final",
  TABLE = "/table",
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Game />,
  },
  {
    path: "/final",
    element: <Final />,
  },
  {
    path: "/table",
    element: <Table />,
  },
]);

export default router;
